import { useState } from 'react';
import axios from 'axios';
import { TOKEN_PURCHASE_ORDER } from '_constants/apiEndpoints';
import toastAlert from 'components/UI/Alert';

const usePurchaseOrderForm = () => {
    const [isLoading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const response = await axios({
                method: 'post',
                url: TOKEN_PURCHASE_ORDER,
                data,
            });

            return response;
        } catch (err) {
            toastAlert({
                type: 'error',
                customMessage: err,
            });
            console.error('usePurchaseOrderForm service error:', err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        isLoading,
        onSubmit,
    };
};

export default usePurchaseOrderForm;
